import { useCallback, useEffect } from 'react';

import { AppState, AppStateStatus } from 'react-native';

import { useDispatch } from 'react-redux';

import { setAppState } from 'store/config/actions.ts';

const useAppState = () => {
    const dispatch = useDispatch();

    const handleAppStateChange = useCallback((nextAppState: AppStateStatus) => {
        dispatch(setAppState(nextAppState));
    }, []);

    useEffect(() => {
        // IOS will have 'inactive' app state initially in the reducer, so we need to update it on app mount.
        handleAppStateChange(AppState.currentState);

        const subscription = AppState.addEventListener(
            'change',
            handleAppStateChange,
        );

        return () => {
            subscription.remove();
        };
    }, []);
};

export default useAppState;
